<div>
    <ol>
        <li *ngFor="let item of listLink">
            <a href={{item.link}}>{{item.title}}</a>
        </li>
    </ol>
</div>
